import transferWrapper from '../components/wrapper';
import React, { FC, memo, useState } from 'react';
import { Button, InputWraper, useForm } from 'modules';
import { InputFile } from '../../../components';
import * as Yup from 'yup';
import { Icon } from '../../../components';
import TableElectricBillList from '../components/tableElectricBillList';
import { PopupWraper } from '../../../components/popup';
import { InputPassword } from 'components';

const ElectricBillUploadFile: FC = transferWrapper(() => {
  const [isShowPopup, setIsShowPopup] = useState<boolean>(true);

  const { getInputProps, handleSubmit, isSubmitting } = useForm({
    structure: [
      {
        name: 'electricBillFile',
        validate: Yup.string().required('Must be provided'),
      },
    ],
    onSubmit: async (values: any) => {
      console.log(values);
    },
  });
  return (
    <div className='electric-bill-upload-file'>
      <div className='electric-bill-upload-file__input'>
        <InputWraper
          className='electric-bill-upload-file__input__file'
          label={'Tải tệp đơn hàng lên'}
          inputProps={getInputProps('electricBillFile')}
          renderInput={(props) => <InputFile {...props} />}
        />
        <Icon.Upload />
      </div>

      <div className='electric-bill-upload-file__action'>
        <Button
          className='electric-bill-upload-file__action__query'
          label={'Truy vấn'}
          type='submit'
          buttonType='success'
          // isLoading={isSubmitting}
          onClick={handleSubmit}
        />

        <Button
          className='electric-bill-upload-file__action__download'
          label={'Tải về biểu mẫu'}
          type='submit'
          buttonType='info'
          // isLoading={isSubmitting}
          onClick={handleSubmit}
        />
      </div>

      <TableElectricBillList />

      {isShowPopup && (
        <PopupWraper
          center
          title='Nhập mật khẩu'
          onClose={() => setIsShowPopup(false)}
        >
          <div className='charge-bill-container'>
            <div className='charge-bill__title'>
              <InputWraper
                label='Mật khẩu'
                inputProps={{
                  value: '123456789',
                  name: 'password',
                  isReadOnly: true,
                  onChange: () => {},
                  onTouched: () => {},
                }}
                component={InputPassword}
              />
            </div>
            <div className='charge-bill__button-container'>
              <Button
                className='button__confirm'
                onClick={() => {}}
                label='Xác nhận'
                buttonType='success'
                type='submit'
              />
              <Button
                className='button__cancel'
                onClick={() => {}}
                label='Trở về'
                buttonType='primary-outline'
              />
            </div>
          </div>
        </PopupWraper>
      )}
    </div>
  );
});

export default ElectricBillUploadFile;
